<template>
  <div>
    <headTop head-title='用户注册' :go-back="true"></headTop>
    <div class="reg-wrap" ref="register">
      <div class="content">
        <ul class="register_ul">
          <li class="register_li">
           <!--  <i class="icon my"></i> -->
           <span class="left_p name"></span><input type="text" placeholder="请输入用户名" v-model="userName" maxlength="16" minlength="4" autocomplete="off">
          </li>
          <li class="register_li">
            <!-- <i class="icon icon_mima"></i> -->
            <span class="left_p pwd"></span><input type="password" placeholder="请输入密码"  v-model="passWord" maxlength="16" minlength="6" autocomplete="off">
          </li>
          <li class="register_li">
            <!-- <i class="icon icon_mima"></i> -->
            <span class="left_p pwd"></span><input type="password" placeholder="请再次输入密码"  v-model="confirmPassWord" maxlength="16" minlength="6" autocomplete="off">
          </li>
          <li class="register_li">
            <!-- <i class="icon icon_c"></i> -->
            <span class="left_p"></span><input class="captcha_wrapper" @focus="showCaptchaEvent" name="captcha" v-model="captcha" type="text" placeholder="请输入验证码" maxlength="16" autocomplete="off"><img ref="captcha_img" @click="changeImg($event)" v-show="showCaptcha" @load="loadImage"/>
          </li>
        </ul>
        <p class="contact" @click="newOpen">
          联系客服
        </p>
        <div class="login-btn">
          <span class="btn" :class="{on:btnShow}" @click="regist()">立即注册</span>
        </div>
        <div class="middleWord">
          <i class="icon" :class="{icon_checkbox:checkboxShow}" @click="ShowBox()"></i>&nbsp;&nbsp;我已同意并阅读
          <router-link to="/explain?type=agreement" tag="span">《服务协议》</router-link>
        </div>
        <div class="minWord">
          已经有ID,
          <span @click="login">快速登录 ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from '@/components/common/header/head'
import { userResource } from '@/resource/resource'
import { mapState, mapMutations } from 'vuex'
import { addCookie } from '@/common/js/cookies'
import { saveToLocal } from '@/common/js/store'
import BScroll from 'better-scroll'
const ERR_OK = 0

  export default {
    name: 'regist',
    data () {
      return {
        captcha: '', // 验证码
        showCaptcha: false,
        checkboxShow: false,
        btnShow: true,
        userName: '',
        passWord: '',
        confirmPassWord: '',
        isSubmit: false,
        invite: '', // 邀请码
        disabled: false
      }
    },
    created () {
    },
    mounted () {
      this.$nextTick(() => {
        this._initScroll()
      })
    },
    computed: {
      ...mapState(['config_info'])
    },
    methods: {
      // 显示验证码图片(用于注册)
      showCaptchaEvent () {
        if (!this.showCaptcha) {
          this.$nextTick(() => {
            userResource.captcha().then(res => {
              this.$refs.captcha_img.src = window.URL.createObjectURL(res.body)
            })
            // this.$refs.captcha_img.src = captchaResource + Date.parse(new Date()) / 1000
          })
        }
        this.showCaptcha = true
      },
      // 更换验证码图片
      changeImg (e) {
        userResource.captcha().then(res => {
          e.target.src = window.URL.createObjectURL(res.body)
        })
        // e.target.src = captchaResource + Date.parse(new Date()) / 1000
      },
      // 验证码加载完成后销毁对象释放内存
      loadImage() {
        window.URL.revokeObjectURL(this.$refs.captcha_img.src)
      },
      ShowBox () {
        this.checkboxShow = !this.checkboxShow
      },
      // 用户注册
      regist () {
        if (this.checkboxShow) {
          this.$toast('请同意用户协议')
        } else if (!this.isSubmit) {
          this.isSubmit = true
          let submitObj = { username: this.userName, password: this.passWord, confirm_password: this.confirmPassWord, captcha: this.captcha }
          userResource.register(submitObj).then(response => {
            response = response.body
            if (response.errcode === ERR_OK) {
              // this.getPopup()
              saveToLocal('token', response.data['access-token'])
              addCookie('isLogined', true, 120)
              // this.getBalance()
              this.getUserInfo()
              if (this.$route.query.redirect) {
                //  let redirect = decodeURIComponent(this.$route.query.redirect)
                let redirect = this.$route.query.redirect
                this.$router.replace(redirect)
              } else {
                this.$router.push('/')
              }
            } else {
              this.isSubmit = false
              this.captcha = ''
              this.$nextTick(() => {
                userResource.captcha().then(res => {
                  this.$refs.captcha_img.src = window.URL.createObjectURL(res.body)
                })
                // this.$refs.captcha_img.src = captchaResource + Date.parse(new Date()) / 1000
              })
            }
          }, () => {
               this.isSubmit = false
               this.captcha = ''
               this.$nextTick(() => {
                userResource.captcha().then(res => {
                  this.$refs.captcha_img.src = window.URL.createObjectURL(res.body)
                })
               // this.$refs.captcha_img.src = captchaResource + Date.parse(new Date()) / 1000
            })
          })
        }
      },
      // 会员等级的信息,信息未读数和任务未读数信息
      getUserInfo() {
        userResource.info().then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.RECORD_USERINFO(res.data)
          }
        })
      },
      // 跳转登录页面
      login () {
        if (this.$route.query.redirect) {
          //  let redirect = decodeURIComponent(this.$route.query.redirect)
          let redirect = this.$route.query.redirect
          this.$router.push({path: 'login', query: {redirect: redirect}})
        } else {
          this.$router.push('/login')
        }
      },
      _initScroll() {
        if (!this.registerScroll) {
          this.registerScroll = new BScroll(this.$refs.register, {
            click: true
          })
        } else {
          this.registerScroll.refresh()
        }
      },
      newOpen () {
        if (this.config_info.service_repwd_url) {
          window.open(this.config_info.service_repwd_url)
        }
      },
      // 更新vuex状态信息
      ...mapMutations([
        'RECORD_USERINFO'
      ])
    },
    watch: {
      // 'showRePage': function(val, oldVal) {
      //   if (val) {
      //     this.$nextTick(() => {
      //       if (!this.registerScroll) {
      //         this.registerScroll = new BScroll(this.$refs.register, {
      //           click: true
      //         })
      //       } else {
      //         this.registerScroll.refresh()
      //       }
      //     })
      //     this.userName = ''
      //     this.passWord = ''
      //     this.confirmPassWord = ''
      //     this.isSubmit = false
      //   }
      // }
    },
    components: {
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../common/stylus/mixin";
  .reg-wrap
    position fixed
    top 0
    left 0
    bottom 0
    width 100%
    background-color #f4f4f4
    .content
      // flex-direction column
      margin-top 0.9rem
      padding-top 0.32rem
      font-size $font-size-m
      width 100%
      background #f4f4f4
      .register_ul
        .register_li
          display flex
          position relative
          background #fff
          box-sizing border-box
          border-bottom 1px solid #f4f4f4
          align-items center
          &:last-child
            border-bottom none
          // .icon
          //   display inline-block
          //   background-size cover
          //   &.my
          //     margin 0.34rem  0.2rem
          //     width 0.21rem
          //     height 0.24rem
          //     bg-image('my')
          //   &.icon_mima
          //     margin 0.34rem  0.2rem
          //     width 0.21rem
          //     height 0.24rem
          //     bg-image('icon_mima')
          //   &.icon_c
          //     margin 0.37rem  0.17rem
          //     width 0.24rem
          //     height 0.21rem
          //     bg-image('icon_c')
          //   &.icon_yqm
          //     margin 0.37rem  0.17rem
          //     width 0.24rem
          //     height 0.24rem
          //     bg-image('icon_yaoqingma')
          & > input
            flex 1
            padding-left 0.6rem
            height 0.96rem
            outline none
            background-color #fff
          & > img
            position absolute
            right 0
            top 0
            width 2.4rem
            height 0.96rem
            background-size cover
            background-repeat no-repeat
          .left_p
            display inline-block
            // margin-left 0.3rem
            line-height 0.96rem
            margin 0 0 0 0.3rem
            text-align right
            color $c-b1
            width 0.24rem
            &.name
              width 0.24rem
              height 0.28rem
              background-size 0.24rem 0.28rem
              bg-image('name')
            &.pwd
              width 0.24rem
              height 0.27rem
              background-size 0.24rem 0.27rem
              bg-image('pwd')
            .red
              color #cd3c29
      .leftWord
        padding-left 0.3rem
        box-sizing border-box
        font-size $font-size-s
        color #666666
        margin-top 0.2rem
        margin-bottom 0.58rem
        .red
          color #cd3c29
          margin 0 0.1rem
        .backW
          color #222222
      .middleWord
        margin 0.32rem 0 0.32rem 0.28rem
        font-size $font-size-s
        text-align left
        line-height 0.24rem
        color #a8a8a8
        & > span
          color $blue
        .icon
          width 0.24rem
          height 0.24rem
          display inline-block
          background-size cover
          bg-image('icon_checkbox_Selected')
          &.icon_checkbox
            bg-image('icon_checkbox')
      .contact
        text-align right
        color $blue
        margin 0.24rem 0.28rem 0.48rem 0
        font-size $fz-t1
      .login-btn
        padding 0 0.28rem
        font-size $font-size-m
        text-align center
        .btn
          display inline-block
          height 0.8rem
          width 100%
          background-color $blue
          border-radius 0.1rem
          text-align center
          line-height 0.8rem
          color #ffffff
          &.on
            background-color $blue
      .minWord
        margin 0.32rem 0
        font-size $font-size-s
        padding-right 0.32rem
        text-align right
        color $blue
        & > span
          color $blue
      .pic
        margin-top 0.7rem
        margin-bottom 0.2rem
        height 0.02rem
        background-size cover
        bg-image('icon_line')
      .prompt
        height 2.0rem
        font-size $font-size-s
        color #666666
        padding-left 0.2rem
        & > h3
          color #222222
        & > span
          display block
          margin-top 0.2rem
</style>



// WEBPACK FOOTER //
// src/components/register/register.vue